import React, { ReactElement, FunctionComponent, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import LabelFont from '../../../Theme/Fonts/Label'

export type GalleryCountLabel = {
    /**
     * number of images of the corresponding gallery teaser
     * */
    numberOfImages: number
    children?: never
}

const GalleryCountLabel: FunctionComponent<GalleryCountLabel> = ({
    numberOfImages,
}): ReactElement => {
    return (
        <Grid horizontal noExpand>
            <Grid
                horizontal
                noExpand
                paddingX={2}
                backgroundColor="onyx"
                borderRadius={1}
                height={18}
                center
            >
                <FontelloIcon name="gallery-active" color="pearl" fontSize={10} marginRight={2} />
                <LabelFont color="pearl">{`${numberOfImages}`}</LabelFont>
            </Grid>
        </Grid>
    )
}

export default memo(GalleryCountLabel)
